export const MENU_DESIGN_TYPE = {
  COLOR: 'Color',
  IMAGE: 'Image',
  NONE: 'None',
} as const;

export type MENU_DESIGN_TYPE_KEY = keyof typeof MENU_DESIGN_TYPE;
export type MENU_DESIGN_TYPE_VALUE =
  typeof MENU_DESIGN_TYPE[MENU_DESIGN_TYPE_KEY];

export const MENU_DESIGN_MAP = {
  [MENU_DESIGN_TYPE.COLOR]: '단색 타입',
  [MENU_DESIGN_TYPE.IMAGE]: '이미지 타입',
  [MENU_DESIGN_TYPE.NONE]: '없음 타입',
};

export const menuDesignList = Object.keys(MENU_DESIGN_MAP).map((key) => {
  return {
    key: key,
    value: MENU_DESIGN_MAP[key],
  };
});
